import type { GetServerSideProps } from 'next/types';
import Head from 'next/head';
import { DealsResults } from '@/components/collections/hotDealsV3/types';
import HotDealsNavPage from '@/components/collections/hotDealsV3';
import settings from '@/settings';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import { getServerSideProps as getDealV3Props } from '@/components/collections/hotDealsV3/getServerSideProps';

const EMPTY_SEARCH: DealsResults = {
  deals: [],
  options: {},
  priceRange: { min: 0, max: 0 },
  hasNextPage: false,
  count: 0,
  haslastMinuteDeals: 0,
  hasBundleOffers: 0,
};

export const getServerSideProps: GetServerSideProps<any> = async (event) => {
  const response = await getDealV3Props(event.query);

  if (response == null) return { props: EMPTY_SEARCH };

  return {
    props: {
      ...response,
    },
  };
};

export default function Deals(props: DealsResults) {
  const isUSStore = settings.store === 'reebelo-us';
  const description = isUSStore
    ? `Reebelo offers amazing deals on certified, 100% functional refurbished tech. Enjoy your favorite sustainable devices up to 40% off with a 12-month warranty.`
    : `Looking for hot tech deals? Shop a wide variety of refurbished phones, laptops, tablets, and more. Up to 40% off with free shipping and 14-day returns.`;

  return (
    <>
      <Head>
        <title>
          {isUSStore
            ? `Explore Hot Deals on Refurbished Tech in USA`
            : `Buy Hot Deals on Refurbished Tech in ${settings.country_code}`}
        </title>
        <WebsiteSchema />
        <meta name="description" content={description} />
      </Head>
      <HotDealsNavPage {...props} />
    </>
  );
}
